import  { GET_SUBSCRIBE_PRICE_SCREEN_DATA } from '../actions/getSubscribePriceScreenActions';


export const getSubscribePriceScreenDataReducer = (
	state: {id:string , topic : string, topicData : any}[] = [
		{ id: 'NORTH_AMERICA_BELGIAN_COCHOLATE', topic: "acme/retail/shopfloor/price/updated/v1/us/nam/51001", topicData : {} },
		{ id: 'NORTH_AMERICA_APPLE', topic: "acme/retail/shopfloor/price/updated/v1/us/nam/51002", topicData : {} },
		{ id: 'EMEA_BELGIAN_COCHOLATE', topic: "acme/retail/shopfloor/price/updated/v1/uk/emea/51001" , topicData : {}},
		{ id: 'EMEA_BELGIAN_APPLE', topic: "acme/retail/shopfloor/price/updated/v1/uk/emea/51002", topicData : {} },
		{ id: 'APJ_BELGIAN_COCHOLATE', topic: "acme/retail/shopfloor/price/updated/v1/jp/apj/51001" , topicData : {}},
		{ id: 'APJ_AAPLE', topic: "acme/retail/shopfloor/price/updated/v1/jp/apj/51002" , topicData : {}},
	  ],
	action: any
): any => {
	switch (action.type) {
		case GET_SUBSCRIBE_PRICE_SCREEN_DATA:
			if(action.payload && action.payload.topicName && action.payload.topicData){
				return state.map((tE:{id:string , topic : string, topicData : any})=>{
					if(tE['topic']===action.payload.topicName){
						return {...tE,topicData : action?.payload?.topicData}
					}
					return tE;
				})
			}else{
                 return action.payload
			}
		default:
			return state;
	}
}

